window.app = window.app || {};

jQuery(function($) {

    function flexCreateToken(xhrOptions, formHelperRequest) {

        if (xhrOptions.data['flex-response'] === '') {

            formHelperRequest.cancel();

            var $form = formHelperRequest.$form;

            var options = {
                expirationMonth: $form.find('#exp-month').val(),
                expirationYear: $form.find('#exp-year').val()
            };

            if (options.expirationMonth !== '' && options.expirationYear !== '') {

                window.app.microform.createToken(options, function (error, token) {

                    if (error) {
                        console.log(error);
                        $form.find('#flex-response').val(JSON.stringify(error));
                    } else {
                        var tokenJSON = JSON.stringify(token);
                        $form.find('#flex-response').val(tokenJSON);
                    }

                    $form.submit();
                });
            }
            else {

                $form.find('#flex-response').val(JSON.stringify({name: 'MissingCardExpiration'}));
                $form.submit();
            }
        }
        else {

            if (window.app.microformFields) {

                $.each(window.app.microformFields, function(key,valueObj) {

                    xhrOptions.data[valueObj.type + '-container'] = 'VALID';
                    if (!valueObj.valid || valueObj.empty) {
                        xhrOptions.data[valueObj.type + '-container'] = '';
                    }
                });
            }
        }
    }

    window.app.flexCreateToken = flexCreateToken;

});
